// removed by extract-text-webpack-plugin
module.exports = {"box":"qempo_PurchaserInfo_box-gF9dlPh","dotsButton":"qempo_PurchaserInfo_dotsButton-2d48kt-","topContent":"qempo_PurchaserInfo_topContent-3CAFQpk","infoWrap":"qempo_PurchaserInfo_infoWrap-znvBJbr","name":"qempo_PurchaserInfo_name-3Mm0AdQ","shippingAddress":"qempo_PurchaserInfo_shippingAddress-iyTpELP","middle":"qempo_PurchaserInfo_middle-MzNEE_M","bottomContent":"qempo_PurchaserInfo_bottomContent-FnlVigZ"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Sale/components/PurchaserInfo/PurchaserInfo.scss
// module id = 1839
// module chunks = 0